import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (context) => ({
  redirect: {
    destination: `/admin/meetings/meet/join/${context.params?.slug}`,
    permanent: false,
  },
});

export default function AdminQuickMeetJoinRedirect() {
  return null;
}
